import { ArraySerializer, Type, Field, Model } from 'serialize-ts';
import { AttributeOption, OptionsRange } from '~shared/models';
import { ModelMetadataSerializer } from 'serialize-ts/dist/serializers/model-metadata.serializer';

@Model()
export class Attribute {
  @Field()
  id: string;

  @Field()
  name: string;

  @Field()
  unit?: string;

  @Field()
  @Type(new ArraySerializer(new ModelMetadataSerializer(AttributeOption)))
  options: AttributeOption[];

  @Field()
  optionsRange?: OptionsRange;
}
